export { BaselineComponent } from './baseline.component';
export { Remediate } from './remediate';
export const href =
    ' https://learn.microsoft.com/en-us/exchange/clients-and-mobile-in-exchange-online/disable-basic-authentication-in-exchange-online#configure-the-default-authentication-policy';
